
// Vue / Vuex
import { Component, Vue, Prop, Emit } from "vue-property-decorator";

// Components
import AreaTreeSelect from '../form/AreaTreeSelect.vue';
import EventFilter from './EventFilter.vue';

// Types
import EventSearchModel from "@/types/eventSearch/EventSearchModel";


@Component({
    components: {
        "event-filter": EventFilter,
        "area-tree-select": AreaTreeSelect
    }
})
export default class AreaFilter extends Vue {
    @Prop({ default: null, type: Object, required: true }) value: EventSearchModel;

    @Prop({ default: false, type: Boolean, required: true }) isMapVisible!: boolean;

    @Emit("toggle-map-visible")
    private toggleMapVisible() {
        //
    }
}
